export const FEEDBACK_PROMPT_KEY = 'amplorium.feedbackPrompt.asked'

const ASKED = 'true'

// A browser that refuses storage (Safari Private, a full quota, blocked site
// data) must not break publishing. An unreadable flag degrades to asking again
// rather than to a crash.
export const hasBeenAsked = (): boolean => {
  try {
    return localStorage.getItem(FEEDBACK_PROMPT_KEY) === ASKED
  } catch {
    return false
  }
}

// localStorage fires no event in the tab that wrote it, so anything rendering
// from this flag would go stale until a reload. Listeners make it observable.
const listeners = new Set<() => void>()

export const subscribeToAsked = (listener: () => void): (() => void) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export const markAsked = (): void => {
  try {
    localStorage.setItem(FEEDBACK_PROMPT_KEY, ASKED)
  } catch {
    // Storage unavailable — the prompt may appear again, which is preferable
    // to failing the flow that triggered it.
  }

  listeners.forEach((listener) => {
    listener()
  })
}
